import React, { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import { schemeColumns } from "../columns/schemeColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn } from "../LedgerResponsive";
import TransactionTable from "./TransactionTable";

export default function SchemeTable({ folio, pan, onOpenModal, onOpenTxnModal }) {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!folio || !pan) return;
    setLoading(true);

    axios
      .get(`${API_BASE}/get_schemes.php?folio_number=${folio}&pan=${pan}&arn_no=${getArn()}`)
      .then((res) => {
        console.log("👉 Schemes API Response:", res.data);
        if (res.data && Array.isArray(res.data.schemes)) {
          setSchemes(res.data.schemes);
        } else {
          setSchemes([]);
        }
      })
      .catch((err) => {
        console.error("❌ Schemes API Error:", err);
        setSchemes([]);
      })
      .finally(() => setLoading(false));
  }, [folio, pan]);

  return (
    <LedgerResponsiveWrapper>
      <Table
        loading={loading}
        columns={schemeColumns(onOpenModal)}
        dataSource={schemes}
        rowKey="scheme_code"
        pagination={false}
        bordered
        expandable={{
          expandedRowRender: (record) => (
            <TransactionTable
              folio={folio}
              pan={pan}
              schemeCode={record.scheme_code}
              onOpenModal={onOpenTxnModal}
            />
          ),
          rowExpandable: () => true,
        }}
      />
    </LedgerResponsiveWrapper>
  );
}
